<fieldset class="sis-radio-fieldset" [class.sis-radio-fieldset--stacked]="!inline">
  <legend class="sis-radio-legend">{{ legend }}</legend>
  <span class="sis-radio-options">
    <label class="sis-radio-option" *ngFor="let option of options">
      <input
        type="radio"
        [name]="name"
        [value]="option.value"
        [checked]="value === option.value"
        [disabled]="disabled || option.disabled"
        (change)="select(option.value)">
      <span class="sis-radio-mark" aria-hidden="true"></span>
      <span class="sis-radio-label">{{ option.label }}</span>
    </label>
  </span>
</fieldset>
